module.exports = __webpack_public_path__ + "static/media/15.33c1793a.jpg";